module.exports = __webpack_public_path__ + "img/droit.5839d85e.svg";